<template>
  <div class="popup_wrap" style="width:1300px;">
    <!-- 팝업사이즈 참고 : 500*235  popup_wrap -->
    <button v-show="isCloseBtn" class="layer_close" @click="$emit('close')">close</button>
    <div class="popup_cont">
      <!-- popup_cont -->

      <h1 class="page_title">{{ $t('msg.CSBL400.001') }}</h1> <!-- Invoice 발행 내역 -->
      <!-- content_box -->
      <div class="content_box">
        <table class="tbl_col">
          <colgroup>
            <col style="width:8%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:6%">
            <col style="width:6%">
            <col style="width:8%">
            <col style="width:8%">
            <col style="width:6%">
            <col style="width:6%">
            <col v-if="isKrUser" style="width:9%">
            <col v-if="isKrUser" style="width:16%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">Invoice No.</th>
              <th scope="col">Issue Date</th>
              <th scope="col">Currency</th>
              <th scope="col">Amount</th>
              <th scope="col">DEM/DET</th>
              <th scope="col">Size</th>
              <th scope="col">Type</th>
              <th scope="col">Container Quantity</th>
              <th scope="col">Extend Date</th>
              <th scope="col">Paid</th>
              <th scope="col">Status</th>
              <th v-if="isKrUser" scope="col">가상계좌</th>
              <th v-if="isKrUser" scope="col">가상계좌번호(은행) </th>
            </tr>
          </thead>
          <tbody v-if="invoiceList.length > 0">
            <tr v-for="(t, i) in invoiceList" :key="'invoice-' + i">
              <td v-if="t.isFirst" :rowspan="t.rowspan">
                <a v-if="isKrUser" href="javascript:void(0)" class="link" @click.prevent="openPopup('demInvoicePop', i)">{{ t.invIssNo }}</a>
                <template v-else>{{ t.invIssNo }}</template>
              </td>
              <td v-if="t.isFirst" :rowspan="t.rowspan">{{ $ekmtcCommon.changeDatePattern(t.issDt, '.') }}</td>
              <td style="border-left: 1px solid #e1e3eb !important;">{{ t.curCd }}</td>
              <td>{{ t.locAmt | comma }}</td>
              <td>{{ getDemDetCatNm(t.demDetCatCd) }}</td> <!-- DET -->
              <td>{{ t.cntrSzCd }}</td>
              <td>{{ t.cntrTypCd }}</td>
              <td>{{ t.cntrQty }}</td>
              <td>{{ $ekmtcCommon.changeDatePattern(t.extsDt, '.') }}</td>
              <td>{{ t.rcvCpltYn === 'Y'? 'paid' : 'No paid' }}</td>
              <td v-if="t.isFirst" :rowspan="t.rowspan">
                <span v-if="t.apvStsCd === '입금완료' || t.apvStsCd === '요청' || t.apvStsCd === '승인' || t.apvStsCd === '거절' || t.apvStsCd === '처리중' || t.apvStsCd === '취소'">
                  <a href="javascript:void(0)" class="link" @click.prevent="openPopup('CalcIssueInvMsgPop', i , getDemDetTableIdx(t.demDetCatCd))">{{ t.apvStsCd }}</a>
                </span>
                <span v-else>{{ t.apvStsCd }}</span>
              </td>
              <td v-if="isKrUser && t.isFirst" :rowspan="t.rowspan">
                <span v-if="t.vaAccntCd === '01'">
                  <a class="button sm" href="javascript:void(0)" @click.prevent="createVaAcct(t.invIssNo, t.locAmt)">가상계좌생성</a>
                </span>
                <span v-if="t.vaAccntCd === '02'">
                  <a class="button red sm" href="javascript:void(0)" @click.prevent="fnVaAcctCnclYn($event, t.invIssNo)">취소</a>
                </span>
              </td>
              <td v-if="isKrUser && t.isFirst" :rowspan="t.rowspan" style="color: red">{{ $ekmtcCommon.isEmpty(t.vaAccntNo) ? '' : t.vaAccntNo+'(하나은행)' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="isKrUser ? 13 : 11">No data</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- content_box // -->
      <div class="mt10 text_center">
        <a class="button blue lg" href="javascript:void(0)" @click.prevent="closePopup">{{ $t('msg.CMBA100.00261') }}</a>
      </div>
      <win-layer-pop class="sample_popup_list">
        <component
          v-if="customComponent"
          :is="customComponent"
          @close="closePopup"
          :parent-info="parentInfoRe"
        />
      </win-layer-pop>
    </div><!-- popup_cont -->
  </div><!-- popup_wrap // -->
</template>

<script>
import searchDemurrageDetailForm from '@/api/rest/settle/searchdemurrageDetailForm'
import demInvoicePop from '@/pages/settle/popup/DemInvoicePop'
import CalcIssue from '@/api/rest/settle/calcIssue'

export default {
  name: 'PreviousIssuedInvoicePop',
  components: {
    demInvoicePop,
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  filters: {
    comma (val) {
      var num = Number(val)
      return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
          return {
              blNo: '',
              demDetCatCd: '',
              eiCatCd: '',
              lang: '',
              cstCd: ''
          }
      }
    }
  },
  data () {
      return {
        params: { },
        invoiceList: [],
        parentInfoRe: {},
        customComponent: null,
        isCloseBtn: true
      }
  },
  computed: {
    // 가상계좌(하나은행 KRW)는 한국 전용. findIssuedInvoice의 vaAccntCd는 국가 구분이 없어
    // ICC 발행 해외 인보이스(미국 USAUSA 등)도 '01'(가상계좌생성)로 내려온다
    // 인보이스 PDF(issued-dem-invoice)도 해외 건이 한국 본사 레터헤드·원화계좌로 출력돼 한국만 링크
    isKrUser () {
      return this.parentInfo.ctrCd === 'KR'
    }
  },
  created () {
      console.log('getInvoicePop created: ')
      // console.log('this.invoicePop.blNo: ', this.parentInfo.blNo)
      // console.log('this.invoicePop.demDetCatCd: ', this.parentInfo.demDetCatCd)
      // console.log('this.invoicePop.eiCatCd: ', this.parentInfo.eiCatCd)

      this.params.blNo = this.parentInfo.blNo
      this.params.demDetCatCd = this.parentInfo.demDetCatCd
      this.params.eiCatCd = this.parentInfo.eiCatCd

      // console.log('blNo', this.params.blNo)
      // console.log('demDetCatCd', this.params.demDetCatCd)
      // console.log('eiCatCd', this.params.eiCatCd)

      this.getInvoice()
  },
  mounted () {
      // this.getInvoice()
  },
  methods: {
    getInvoice () {
      console.log('params: ', this.params)
      searchDemurrageDetailForm.getInvoice(this.params).then(response => {
        console.log('response ::: ', response)
        const data = response.data
        this.invoiceList = this.parseInvoiceList(data.rstList)
        console.log('resp.rstCnt: ', data.rstCnt)
        console.log('resp.rstList: ', data.rstList)
      })
    },
    parseInvoiceList (list) {
      let res = []
      for (let i = 0; i < list.length; i++) {
        list[i].isFirst = true
        list[i].rowspan = 1
        for (let j = 0; j < res.length; j++) {
          if (list[i].invIssNo === res[j].invIssNo) {
            list[i].isFirst = false
            res[j].rowspan++
            break
          }
        }
        res.push(list[i])
      }
      console.log(res)
      return res
    },
    openPopup (compNm, idx, tableIdx) {
      if (compNm === 'CalcIssueInvMsgPop') {
        this.$emit('child', {
          type: 'openPopup',
          payload: {
            compNm: compNm,
            idx: tableIdx,
            freeTimeInvoice: JSON.parse(JSON.stringify(this.invoiceList[idx]))
          }
        })
      } else {
        if (this.customComponent !== null) {
          this.customComponent = null
          this.$ekmtcCommon.layerClose('.sample_popup_list')
        }
        this.parentInfoRe = {
          invoice: JSON.parse(JSON.stringify(this.invoiceList[idx])),
          blNo: this.parentInfo.blNo,
          lang: this.parentInfo.lang,
          usrNm: this.parentInfo.usrNm,
          ctrCd: this.parentInfo.ctrCd,
          demDetCatCd: this.parentInfo.demDetCatCd,
          eiCatCd: this.parentInfo.eiCatCd
        }
        this.isCloseBtn = false
        this.customComponent = compNm
        this.$ekmtcCommon.layerOpen('.sample_popup_list')
      }
    },
    closePopup (obj) {
      this.isCloseBtn = true
      this.customComponent = null
      this.$ekmtcCommon.layerClose('.sample_popup_list')
      this.$store.commit('settle/updateIsRefreshFreetimeReq', true)
      this.$emit('close')
    },
    getDemDetCatNm (cd) {
      if (cd === '01') {
        return 'DEM'
      } else if (cd === '02') {
        return 'DET'
      } else if (cd === '03') {
        return 'COM'
      } else if (cd === '04') {
        return 'MOR'
      } else if (cd === '14') {
        return 'OFC'
      } else if (cd === '44') {
        return 'VAC'
      } else {
        return ''
      }
    },
    async fnVaAcctCnclYn (e, invIssNo) {
      let param = {
        blNo: this.parentInfo.blNo,
        invIssNo: invIssNo
      }
      if (!await this.$ekmtcCommon.asyncAlertMessage({
        message: '가상계좌를 취소하시겠습니까?',
        useConfirmBtn: true
      })) {
        return
      }
      await CalcIssue.cancelVirtualAccount(param).then(response => {
        $(e.target).hide()
        this.$ekmtcCommon.asyncAlertMessage({ message: '정상적으로 취소되었습니다.' })
      }).catch(e => {
        console.log(e)
      })
    },
    async createVaAcct (invIssNo, locAmt) {
      this.$emit('openVaAccntPopup', {
        compNm: 'VirtualAccountInvoiceInfo',
        idx: this.parentInfo.idx,
        invIssNo: invIssNo,
        locAmt: locAmt
      })
      //this.$emit('close')
    },
    getDemDetTableIdx (cd) {
      if (cd === '01') {
        return '0'
      } else if (cd === '02') {
        return '1'
      } else if (cd === '03') {
        return '2'
      } else if (cd === '04') {
        return '4'
      } else if (cd === '14') {
        return '3'
      }
    }
  }

    }
</script>

<style lang="scss" scoped>

</style>
